import getEnv from '../src/utils/env';
const BuildConfig = {
  VUE_APP_ALERT_V2_ENABLE: getEnv('VUE_APP_ALERT_V2_ENABLE'),
  VUE_APP_ALERT_V2_NC_ENABLE: getEnv('VUE_APP_ALERT_V2_NC_ENABLE'),
  VUE_APP_DISABLE_ICON: getEnv('VUE_APP_DISABLE_ICON'),
  VUE_APP_ALERT_V2_TAG_GROUP_ENABLE: getEnv(
    'VUE_APP_ALERT_V2_TAG_GROUP_ENABLE',
  ),
  VUE_APP_IS_WHITE_LABEL: getEnv('VUE_APP_IS_WHITE_LABEL'),
  VUE_APP_ACTIVE_CAPABILITIES: getEnv('VUE_APP_ACTIVE_CAPABILITIES'),
  VUE_APP_DOCS_BASE_URL: getEnv('VUE_APP_DOCS_BASE_URL'),
  VUE_APP_ALERT_V2_EXT_TAG_GROUP_ENABLE: getEnv(
    'VUE_APP_ALERT_V2_EXT_TAG_GROUP_ENABLE',
  ),
  VUE_APP_NOTIFICATION_HOST: getEnv('VUE_APP_NOTIFICATION_HOST'),
  VUE_APP_SETTING_NOTIFICATION_ENABLE: getEnv(
    'VUE_APP_SETTING_NOTIFICATION_ENABLE',
  ),
  VUE_APP_DISABLE_DOC_CAPABILITIES: getEnv('VUE_APP_DISABLE_DOC_CAPABILITIES'),
  VUE_APP_DISABLE_DX: getEnv('VUE_APP_DISABLE_DX'),
  VUE_APP_ENABLE_OC_INTEGRATION: getEnv('VUE_APP_ENABLE_OC_INTEGRATION'),
  VUE_APP_OC_KEY_CLOCK_URL: getEnv('VUE_APP_OC_KEY_CLOCK_URL'),
  VUE_APP_OC_CLIENT_ID: getEnv('VUE_APP_OC_CLIENT_ID'),
  VUE_APP_OC_REDIRECT_URI: getEnv('VUE_APP_OC_REDIRECT_URI'),
  VUE_APP_USER_ACCOUNTS_LIMIT: getEnv('VUE_APP_USER_ACCOUNTS_LIMIT'),
  VUE_APP_ENABLE_ENDPOINTS_EXCLUDE: getEnv('VUE_APP_ENABLE_ENDPOINTS_EXCLUDE'),
  VUE_APP_ENDPOINT_GROUP_LIMIT: getEnv('VUE_APP_ENDPOINT_GROUP_LIMIT'),
  VUE_APP_ENDPOINT_EXCLUDE_LIMIT: getEnv('VUE_APP_ENDPOINT_EXCLUDE_LIMIT'),
  VUE_APP_ENDPOINT_NAME_CHAR_LIMIT: getEnv('VUE_APP_ENDPOINT_NAME_CHAR_LIMIT'),
};
export default Object.freeze(BuildConfig);
